(function () {
  var cible = 'bouquet-blanc-prestige-roses-avalanche-orchidees';

  function appliquer() {
    if (window.location.pathname.split('/').pop() !== cible) return;
    var m = document.createElement('meta');
    m.setAttribute('name', ['ro', 'bots'].join(''));
    m.setAttribute('content', ['no', 'index'].join(''));
    document.head.appendChild(m);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appliquer);
  } else {
    appliquer();
  }
})();